<template>
  <base-modal-bottom
    ref="baseModalError"
    class="has-text-centered"
    :isFooter="true"
    :title="title"
  >
    <template #btn-close-icon>
      <base-icon
        style="margin: 0 auto"
        width="16"
        height="16"
        name="painel/close-icon"
      />
    </template>
    <div class="margin-bottom">
      <base-icon width="156" height="114" :name="icon" />
    </div>
    <div class="margin-bottom title-message">
      <p>{{ message }}</p>
    </div>
    <p class="margin-bottom subtitle-message" v-html="subMessage"></p>
    <template #footer>
      <base-button-bottom
        @click.native="close"
        class="is-primary is-big button"
        type="button"
      >
        Ok, entendi!
      </base-button-bottom>
    </template>
  </base-modal-bottom>
</template>

<script>
import BaseModalBottom from '@/components/BaseModalBottom.vue'
import BaseButtonBottom from '@/components/BaseButtonBottom.vue'

export default {
  props: {
    title: {
      type: String,
      default: 'Pagamento não identificado',
    },
    icon: {
      type: String,
      default: 'painel/depositMoneyError',
    },
    message: {
      type: String,
      default: 'Ops, ainda não identificamos o seu pagamento',
    },
    subMessage: {
      type: String,
      default:
        'O valor será creditado em até <strong>5 minutos</strong> em sua Carteira, <strong>atualize a página em instantes.</strong><br/><br/>Caso seu crédito não esteja disponível <strong>após este período</strong>, entre em contato com o nosso atendimento para que possamos te ajudar ;)',
    },
  },

  components: {
    BaseModalBottom,
    BaseButtonBottom,
  },

  methods: {
    open() {
      this.$refs.baseModalError.open()
    },
    close() {
      this.$refs.baseModalError.close()
    },
  },
}
</script>

<style lang="scss" scoped>
.button {
  min-width: 320px !important;
}

.title-message,
.subtitle-message {
  max-width: 429px;
  margin: 0 auto;
  margin-bottom: 24px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: #8493a2;

  strong {
    color: #8493a2;
  }

  .txt-color-support {
    color: #048a8b;
    font-weight: bold;
  }
}

.title-message {
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.11;
  letter-spacing: normal;
  text-align: center;
  color: #8493a2;
}

.margin-bottom {
  margin-bottom: 16px;
}
</style>
